
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h2 
              className="text-3xl md:text-4xl lg:text-5xl font-light text-[#2C3E2D] mb-8 leading-tight tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              <span className="font-medium">Conciergerie à Perpignan</span> et <span className="italic">Pyrénées-Orientales</span>
            </h2>
            <div className="w-20 h-0.5 bg-[#6B7C59] mx-auto mb-10"></div>
            <p 
              className="text-lg md:text-xl text-[#4A5240] max-w-3xl mx-auto leading-relaxed font-light"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Nova Conciergerie est votre partenaire local de confiance pour la <span className="font-normal">gestion de locations saisonnières dans le 66</span>
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/79237683e9ba10f5e0240023cd0edfec/710deefa8c7fc4c854f130ea318f2b42.jpeg"
                alt="Conciergerie location saisonnière Perpignan - Service d'accueil professionnel"
                className="w-full h-[450px] object-cover rounded-3xl shadow-2xl"
              />
            </div>

            <div className="space-y-8">
              <p 
                className="text-base md:text-lg text-[#2C3E2D] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Nous sommes basés dans les <span className="font-normal">Pyrénées-Orientales</span>, proche de <span className="font-normal">Perpignan</span>, et nous vous accompagnons dans la gestion complète de vos résidences secondaires et locations saisonnières.
              </p>
              
              <p 
                className="text-base md:text-lg text-[#2C3E2D] leading-relaxed font-light"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Notre mission est simple : vous permettre de profiter pleinement de votre bien sans les contraintes de gestion. Nous mettons notre <span className="font-normal text-[#6B7C59]">rigueur</span>, notre <span className="font-normal text-[#6B7C59]">disponibilité</span> et notre <span className="font-normal text-[#6B7C59]">soin du détail</span> au service de votre tranquillité d'esprit.
              </p>

              <div className="grid grid-cols-3 gap-8 pt-8">
                <div className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mx-auto mb-4">
                    <i className="ri-shield-check-line text-2xl text-[#6B7C59]"></i>
                  </div>
                  <p className="text-sm font-normal text-[#2C3E2D] tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                    Rigueur
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mx-auto mb-4">
                    <i className="ri-time-line text-2xl text-[#6B7C59]"></i>
                  </div>
                  <p className="text-sm font-normal text-[#2C3E2D] tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                    Disponibilité
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#6B7C59]/10 rounded-2xl mx-auto mb-4">
                    <i className="ri-star-line text-2xl text-[#6B7C59]"></i>
                  </div>
                  <p className="text-sm font-normal text-[#2C3E2D] tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                    Excellence
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
